import { makeDefaultApi } from './request';
import { I18nText } from '../i18n_text';

export interface MeasurementMetaTagData {
  id?: string;
  name_json: I18nText;
  code?: string;
}

export interface ListParams {
  ids?: string[];
  /** The React table's filter model, serialised, and its sort keys. */
  filter?: string;
  sort?: string[];
}

export const { list, retrieve, save, remove } = makeDefaultApi<MeasurementMetaTagData, ListParams>(
  'measurement_meta_tags'
);
